module.exports = __webpack_public_path__ + "static/media/audi.961f5e9c.jpg";